
import VuexEntities from '@/core/shared/orm/plugin/plugin';
import defineSchema from '../orm/models';
console.log(VuexEntities);

export default VuexEntities({ namespace: 'orm', defineSchema });
